import React from 'react';
import PropTypes from 'prop-types';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
// import { IconButton } from '@material-ui/core';
import Icon from '@atoms/Icon';
import { SOCIAL_TYPES } from '../../../constants';
import { IconButton } from './style';

const SocialButton = ({ url, type }) => {
  let icon = null;
  switch (type) {
    case SOCIAL_TYPES.FACEBOOK:
      icon = <FacebookIcon />;

      break;

    case SOCIAL_TYPES.INSTAGRAM:
      icon = <InstagramIcon />;
      break;

    case SOCIAL_TYPES.TWITTER:
      icon = <TwitterIcon />;
      break;

    case SOCIAL_TYPES.LINKEDIN:
      icon = <LinkedInIcon />;
      break;

    case SOCIAL_TYPES.YOUTUBE:
      icon = <YouTubeIcon />;
      break;

    case SOCIAL_TYPES.SOUND_CLOUD:
      icon = <Icon icon="soundcloud" />;
      break;

    default:
      break;
  }

  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a href={url} target="_blank">
      <IconButton color="primary" aria-label="link">
        {icon}
      </IconButton>
    </a>
  );
};

SocialButton.propTypes = {
  url: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default SocialButton;
